import React from 'react';
import Game from './Game.js'

function App() {
    return (
      <Game />
    )
  }
  
  export default App